import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const APP_TZ = 'Asia/Qyzylorda';

/**
 * Возвращает UTC ISO границы периода с учётом TZ Asia/Qyzylorda
 * - today: текущие сутки
 * - yesterday: предыдущие сутки
 * - week: последние 7 дней, включая сегодня (сегодня-6 .. сегодня)
 * - month: текущий месяц
 * - custom: по входным датам (start,end) в любой форме (Date/string/dayjs/moment)
 */
export function buildPeriodRange(options = {}) {
  const { type = 'custom', start, end } = options;

  let startTz;
  let endTz;

  const now = dayjs().tz(APP_TZ);

  switch (type) {
    case 'today':
      startTz = now.startOf('day');
      endTz = now.endOf('day');
      break;
    case 'yesterday':
      startTz = now.subtract(1, 'day').startOf('day');
      endTz = now.subtract(1, 'day').endOf('day');
      break;
    case 'week':
      startTz = now.subtract(6, 'day').startOf('day');
      endTz = now.endOf('day');
      break;
    case 'month':
      startTz = now.startOf('month');
      endTz = now.endOf('month');
      break;
    default: {
      const s = start;
      const e = end;
      const toDj = (d) => {
        // поддержка moment/dayjs/Date/string
        if (!d) return null;
        if (typeof d?.tz === 'function' && typeof d?.toDate === 'function') {
          // moment
          return dayjs(d.toDate()).tz(APP_TZ);
        }
        if (typeof d?.isValid === 'function') {
          // dayjs
          return dayjs(d).tz(APP_TZ);
        }
        return dayjs(d).tz(APP_TZ);
      };
      const djStart = toDj(s) || now.startOf('day');
      const djEnd = toDj(e) || now.endOf('day');
      startTz = djStart.startOf('day');
      endTz = djEnd.endOf('day');
    }
  }

  return {
    fromUTC: startTz.utc().toISOString(),
    toUTC: endTz.utc().toISOString(),
  };
}


